export default "__VITE_ASSET__B4zY9kWi__"